import InputField from "../../../components/InputField";

export default function ContractOriginalStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <InputField
        label="Număr contract"
        value={data.numarContract}
        onChange={update("numarContract")}
        placeholder="ex: 123"
        half
        error={errors.numarContract}
        helperText="Opțional — dacă nu este numerotat, se completează automat"
      />
      <InputField
        label="Data contractului"
        value={data.dataContract}
        onChange={update("dataContract")}
        type="date"
        required
        half
        error={errors.dataContract}
      />
      <InputField
        label="Adresa imobilului"
        value={data.adresaImobil}
        onChange={update("adresaImobil")}
        placeholder="ex: Str. Exemplu nr. 1, Ap. 5, București"
        required
        error={errors.adresaImobil}
      />
    </div>
  );
}
